module.exports = __webpack_public_path__ + "220e324e55b25001a8ede90bc41b9554.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/grachio-ui.png
// module id = 260
// module chunks = 1